export default "__VITE_ASSET__LDESt8ps__"